import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Rule, TechStack } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../shared/error-handling/error-handling.service";
import { API_ENDPOINTS } from "../insight-egrc-api-endpoints";

interface GetTechStackControlsResponse {
  techStackControls: TechStack[];
}

interface GetTechStackControlResponse {
  techStackControl: TechStack;
}

@Injectable({
  providedIn: "root",
})
export class TechStackControlService {
  private readonly apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) { }


  getTechStackControls(
    currentPage: number,
    sessionId: string,
    userId: string
  ): Observable<TechStack[]> {
    const headers = {
      sessionId: sessionId,
      userId: userId,
    };

    return this.http
      .post<GetTechStackControlsResponse>(
        `${this.apiUrl}${API_ENDPOINTS.TECHSTACKCONTROL.FETCH}`,
        {
          currentPage,
        },
        {
          headers: headers, // Add the custom headers
        }
      )
      .pipe(
        map((response) => response.techStackControls),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getTechStackControlSearch(
    currentPage: number,
    searchText: String,
    filterByHeader: String
  ): Observable<TechStack[]> {
    return this.http
      .post<GetTechStackControlsResponse>(`${this.apiUrl}${API_ENDPOINTS.TECHSTACKCONTROL.SEARCH}`, {
        currentPage,
        searchText,
        filterByHeader,
      })
      .pipe(
        map((response) => response.techStackControls),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }


  getTechStackControl(techStackControlId: string): Observable<TechStack> {
    return this.http
      .post<GetTechStackControlResponse>(`${this.apiUrl}${API_ENDPOINTS.TECHSTACKCONTROL.GET}`, {
        techStackControlId,
      })
      .pipe(
        map((response) => response.techStackControl),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  createTechStackControl(
    name: string,
    type: string
  ): Observable<TechStack> {
    return this.http
      .post<TechStack>(`${this.apiUrl}${API_ENDPOINTS.TECHSTACKCONTROL.CREATE}`, {
        name,
        type
      })
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  updateTechStackControl(
    techStackControlId: string,
    name: string,
    type: string,
  ): Observable<TechStack> {
    return this.http
      .post<TechStack>(`${this.apiUrl}${API_ENDPOINTS.TECHSTACKCONTROL.UPDATE}`, {
        techStackControlId,
        name,
        type
      })
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  deleteTechStackControl(techStackControlId: string): Observable<TechStack> {
    return this.http
      .post<TechStack>(`${this.apiUrl}${API_ENDPOINTS.TECHSTACKCONTROL.DELETE}`, { techStackControlId })
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }
}